export default "__VITE_ASSET__D6yIQ6go__"